import '@/styles/index.css';
import type { Messages } from 'next-intl';
import { NextIntlClientProvider } from 'next-intl';
import type { AppProps } from 'next/app';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { GoogleTagManager } from '@next/third-parties/google';

type Props = AppProps & {
  pageProps: {
    messages?: Messages;
    [key: string]: any;
  };
};

export default function App({ Component, pageProps }: Props) {
  const router = useRouter();
  useEffect(() => {
    if (pageProps?.site?.html_lang) {
      document.documentElement.lang = pageProps.site.html_lang;
    }
  }, [pageProps?.site?.html_lang]);

  return (
    <>
      <GoogleTagManager gtmId="GTM-583SBLW" />
      <NextIntlClientProvider locale={router.locale || 'en'} timeZone="Europe/Paris" messages={pageProps.messages || {}}>
        <Component {...pageProps} />
      </NextIntlClientProvider>
    </>
  );
}
